import { Helmet } from "react-helmet";
import {
    Box,
    Container,
    Typography,
} from "@mui/material";
import arrow from "../../assets/images/arrow-right.svg";
import { ReactComponent as ProfileW } from "../../assets/images/profile/profile-w.svg";
import { ReactComponent as PasswordB } from "../../assets/images/profile/password-b.svg";
import { ReactComponent as SettingB } from "../../assets/images/profile/setting-b.svg";
import { ReactComponent as ExitB } from "../../assets/images/profile/exit-b.svg";
import { makeStyles } from "@mui/styles";
import SetLanguage from "./SetLanguage";
import ProfileHistorys from "./ProfileHistorys";
import ChangePassword from "./ChangePassword";
import { logout } from "../../actions/auth";
import { useDispatch, useSelector } from "react-redux";
import {
    NavLink as RouterLink,
    matchPath,
    useLocation,
    useNavigate,
    useParams
} from 'react-router-dom';
import profileService from "../../services/profile.service";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as Util from "../../services/global.service";

// import { color, maxWidth } from "@material-ui/system";
const useStyles = makeStyles({
    boxActive: {
        background: "#5DA196",
        display: "flex",
        padding: "7px 5px 6px 15px",
        width: "100%",
        borderRadius: "4px",
        color: "#FFFFFF",
        margin: "8px 0",
        cursor: "pointer",
        alignItems: "center",
        "&:hover": {
            backgroundColor: "#4f8a80",
        },
        "svg": {
            fill: "red"
        }
    },
    box: {
        background: "#ffffff",
        display: "flex",
        padding: "7px 5px 6px 15px",
        width: "100%",
        borderRadius: "4px",
        color: "#252B42",
        margin: "9px 0 8px",
        cursor: "pointer",
        alignItems: "center",
        "&:hover": {
            backgroundColor: "#5da19626",
        }
    },
    boxLast: {
        marginBottom: "0",
    },
    fillWhite: {
        '& > path': {
            fill: '#FFFFFF'
        },
        '& g > path': {
            fill: '#FFFFFF'
        },
    },
    fillBlack: {
        '& > path': {
            fill: '#404349'
        },
        '& g > path': {
            fill: '#404349'
        },
    },
});
const styles = {
    container: {
        minHeight: "calc(100vh - 64px)",
        paddingTop: "30px"
    },
    tabTop: {
        display: "inline-flex"
    },
    iconTab: {
        margin: "0 13px",
        display: "block"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
        fontWeight: "400"
    },
    activeText: {
        color: "#A3A3A3",
        fontWeight: "400",
        paddingRight: "5px"
    },
    boxMain: {
        display: "flex",
        flexDirection: "row",
        paddingTop: "28px"
    },
    boxLeft: {
        width: "200px",
        padding: "6px 14px 8px",
        backgroundColor: "#ffffff",
        marginRight: "35px"
    },
    boxRight: {
        width: "calc(100% - 205px)",
        background: "#FFFFFF",
        boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        position: "relative"
    },
    line: {
        borderBottom: "0.5px solid #E7E8E7"
    },
    textBox: {
        color: "#BBBEBE",
        fontWeight: "500",
        paddingBottom: "7px",
    },
    iconBox: {
        width: "18px",
        height: "18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        marginRight: "9px"
    },
    icon: {
        display: "block",
        margin: "auto",
        maxWidth: "100%",
        maxHeight: "100%",
    }
};

const Profile = () => {
    const { t } = useTranslation();
    const [values, setValues] = useState({
        options: 'profile',
    });
    const [dataProfile, setDataProfile] = React.useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const classes = useStyles();
    let { refresh } = useParams();

    const [isSSO, setIsSSO] = useState(false)

    //const dataProfiles = JSON.parse(localStorage.getItem("user"));
    //const isSSO = (dataProfiles?.is_sso)


    const changeOptions = (val) => {
        if (val == 'profile') {
            handleGetProfile()
        }
        setValues({
            ...values,
            options: val
        });
    };
    useEffect(() => {
        if (refresh) {
            changeOptions("setting")
        }
        handleGetProfile()
    }, []);

    useEffect(() => {
        setIsSSO(!dataProfile?.configuration?.forget_password)

    }, [dataProfile])

    const handleGetProfile = () => {
        profileService.profile().then(
            (response) => {
                setDataProfile(response.data)
            },
        )
    };
    const signOut = () => {
        dispatch(logout()).then(
            (response) => {
                localStorage.removeItem("user");
                localStorage.removeItem("date");
                localStorage.removeItem("proxy");
                let pathTologin = response?.data?.data?.url
                if (Util.formatData(pathTologin, false) !== false) {
                    const newWindow = window.open(pathTologin, '_self', 'noopener,noreferrer')
                    if (newWindow) newWindow.opener = null
                } else {
                    console.log('Navigate', 17);
                    //navigate('/' + localStorage.getItem("site"), { replace: false });
                    window.location.href = '/' + localStorage.getItem("site")
                }
            }
        ).catch((err) => {
            localStorage.removeItem('date');
            localStorage.removeItem('user');
            localStorage.removeItem("proxy");
            console.log('Navigate', 18);
            //navigate('/' + localStorage.getItem("site"), { replace: false });
            window.location.href = '/' + localStorage.getItem("site")
        })
    };
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    return (
        <>
            <Helmet>
                <title>PROFILE | PMS </title>
            </Helmet>

            <Container maxWidth="xl" style={styles.container}>
                <div style={styles.tabTop}>
                    <Typography fontSize={14} lineHeight="24px" style={styles.link} onClick={() => clickLink('/kpi/home')}>{t(`label.home`)} <span style={styles.activeText}>/ </span></Typography>
                    {/* <img src={arrow} alt="arrowImage" style={styles.iconTab} /> */}
                    {values.options === "profile" ?
                        <Typography fontSize={14} lineHeight="24px" style={styles.activeText}>{t(`label.profile`)}</Typography> :
                        null}
                    {values.options === "setting" ?
                        <Typography fontSize={14} lineHeight="24px" style={styles.activeText}>{t(`label.setting`)}</Typography> :
                        null}
                </div>
                <Box style={styles.boxMain}>
                    <Box>
                        <Box style={styles.boxLeft} >
                            <Typography fontSize={14} lineHeight="24px" style={styles.textBox}>{t(`label.menu`)}</Typography>
                            <Box class={values.options === "profile" ? `${classes.boxActive}` : `${classes.box}`} onClick={(e) => changeOptions("profile")}>
                                <Box style={styles.iconBox} >
                                    <ProfileW class={values.options === "profile" ? `${classes.fillWhite}` : `${classes.fillBlack}`} />
                                </Box>
                                <Typography fontSize={14} lineHeight="24px">{t(`label.profile`)}</Typography>

                            </Box>

                            {!isSSO &&
                                <>
                                    <Box style={styles.line} ></Box>
                                    <Box class={values.options === "password" ? `${classes.boxActive}` : `${classes.box}`} onClick={(e) => changeOptions("password")}>
                                        <Box style={styles.iconBox} >
                                            <PasswordB class={values.options === "password" ? `${classes.fillWhite}` : `${classes.fillBlack}`} />
                                        </Box>
                                        <Typography fontSize={14} lineHeight="24px">{t('profile.changePassword')}</Typography>
                                    </Box>
                                </>
                            }

                            <Box style={styles.line} ></Box>
                            <Box class={values.options === "setting" ? `${classes.boxActive}` : `${classes.box}`} onClick={(e) => changeOptions("setting")}>
                                <Box style={styles.iconBox} >
                                    <SettingB class={values.options === "setting" ? `${classes.fillWhite}` : `${classes.fillBlack}`} />
                                </Box>
                                <Typography fontSize={14} lineHeight="24px">{t(`label.setting`)}</Typography>
                            </Box>

                            {isSSO && false &&
                                <>
                                    <Box style={styles.line} ></Box>
                                    <Box class={`${classes.box} ${classes.boxLast}`} onClick={(e) => signOut()}>
                                        <Box style={styles.iconBox} >
                                            <ExitB class={`${classes.fillBlack}`} />
                                        </Box>
                                        <Typography fontSize={14} lineHeight="24px">{t(`sidebar.label.logOut`)}</Typography>
                                    </Box>
                                </>
                            }

                        </Box>
                    </Box>
                    {values.options === "profile" ?
                        <Box style={styles.boxRight} ><ProfileHistorys datas={dataProfile} /></Box> :
                        null}
                    {values.options === "password" ?
                        <Box style={styles.boxRight} ><ChangePassword /></Box> :
                        null}
                    {values.options === "setting" ?
                        <Box style={styles.boxRight} ><SetLanguage /></Box> :
                        null}
                </Box>
            </Container>
        </>
    );
};
export default Profile;
